<!--动态图对象 右键属性-->
<template>
  <div class="time-event-dialog">
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? name + '-趋势记录' : '新建' + '-曲线图-趋势记录'" :has-form="true" class="time-event-dialog-modal"
      @close="close" @confirm="handleConfirm" width="33%">
      <!--   <div>
        <a
          class="gs-modal-close"
          style="left: 88%;top: 13px"
        >
          <i
            class="el-icon-question"
            style="font-size: 17px;color: #737373"
            @click="dialogHelp = true"
          ></i>
        </a>
      </div> -->
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="50px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <gs-input v-model="description" />
            </gs-form-item>
            <!--<gs-form-item
              label="值"
              prop="target"
              class="form-item-radio"
            >
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="近似值"></el-checkbox>
              <el-checkbox label="已编辑值"></el-checkbox>
              <el-checkbox label="估计值"></el-checkbox>
            </el-checkbox-group>
            </gs-form-item>-->
            <!--  <div class="fifty-width-box">
              <fieldset>
                <legend>主Y轴</legend>
                <gs-checkbox
                  v-model="form.primaryY_autoScale"
                  @change="onChange"
                >自动比例</gs-checkbox>
                <gs-form-item
                  label="最小值"
                  prop="target"
                  class="form-item-radio"
                >
                  <gs-input
                    v-model="form.primaryY_Mininum"
                    :disabled="form.primaryY_autoScale"
                  />
                </gs-form-item>
                <gs-form-item
                  label="最大值"
                  prop="target"
                  class="form-item-radio"
                >
                  <gs-input
                    v-model="form.primaryY_maximum"
                    :disabled="form.primaryY_autoScale"
                  />
                </gs-form-item>
              </fieldset>
            </div>
            <div class="fifty-width-box">
              <fieldset>
                <legend>副Y轴</legend>
                <gs-checkbox
                  v-model="form.secondaryY_autoScale"
                  @change="onChange"
                >自动比例</gs-checkbox>
                <gs-form-item
                  label="最小值"
                  prop="target"
                  class="form-item-radio"
                >
                  <gs-input
                    v-model="form.secondaryY_Mininum"
                    :disabled="form.secondaryY_autoScale"
                  />
                </gs-form-item>
                <gs-form-item
                  label="最大值"
                  prop="target"
                  class="form-item-radio"
                >
                  <gs-input
                    v-model="form.secondaryY_maximum"
                    :disabled="form.secondaryY_autoScale"
                  />
                </gs-form-item>
              </fieldset>
            </div>-->
          </gs-form>
        </gs-tab-pane>
        <!--   <gs-tab-pane
          label="时间"
          name="last"
        >
          <div class="top-form">
            <gs-form
              :model="form"
              label-width="95px"
              label-position="left"
              gap="small"
            >

              <gs-form-item
                label="开始时间"
                prop="target"
              >
                <gs-date-picker
                  v-model="startTime"
                  :default-time="defaultTime"
                  type="date-time"
                />
              </gs-form-item>
              <gs-form-item
                label="结束时间"
                prop="target"
              >
                <gs-date-picker
                  v-model="stopTime"
                  :default-time="defaultTime"
                  type="date-time" 
                />
              </gs-form-item>
            </gs-form>
          </div>
        </gs-tab-pane> -->
        <gs-tab-pane label="动态图" name="second">
          <div>
            <span @click="add" class="addTree">添加对象</span>
            <div class="form-item-objectSeries">

              <el-table :data="form.objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%">
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <!-- <el-table-column prop="type" label="类型" align="center">
                </el-table-column> -->
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete" @click="delObjectSeriesArray(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  <div>
              <fieldset>
                <legend>将计算应用与趋势日志</legend>
                <span>计算方式：</span>
                <gs-select v-model="calculation" style="width: 177px;">
                  <gs-option
                    v-for="item in calculations"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </gs-option>
                </gs-select>
              </fieldset>

            </div>-->
            <!--  <div class="bottom-btn">
              <gs-button @click="add">添加</gs-button>
            </div> -->
          </div>

        </gs-tab-pane>
        <!-- <gs-tab-pane
          label="采样"
          name="third"
        >
          <fieldset>
            <legend>采样设置</legend>
            <span>采样间隔：</span>
            <gs-input
              v-model="form.logInterval_value"
              style="width:100px;"
            />
            <gs-select
              v-model="form.logInterval_unit"
              class="doc-select"
              style="width:100px"
            >
              <gs-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :disabled="item.disabled"
                :value="item.value"
              />
            </gs-select>
            <div style="margin-top:20px;">
              <span>采样最大数：</span>
              <gs-input
                v-model="form.maxLogNum"
                style="width:100px"
              />
            </div>
          </fieldset>
        </gs-tab-pane>-->
        <!-- <gs-tab-pane
          label="定时任务补偿"
          name="fourth"
        >定时任务补偿</gs-tab-pane> -->
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <gs-button type="primary" size="mini" @click="dialogHelp = true">帮 助</gs-button>
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <div style="width: 100%;height: 500px">
        <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
          :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
      </div>
    </gs-modal>
    <gs-modal v-model="visibleProperties" :before-close="beforeCloseProperties" class="my-test-class" title="属性"
      @close="closeProperties" @confirm="handleConfirmProperties">
      <gs-select />
    </gs-modal>
    <gs-modal title="帮助-曲线图-趋势记录" v-model="dialogHelp" class="my-test-class" width="42%"
      :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势记录曲线图对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">对该对象的描述</span><br>
      选择自动缩放以自动缩放轴。 最小-仅在不使用自动缩放时可用。设置轴的最小值。 最大-仅在不使用自动缩放时可用。设置轴的最大值。
      <span class="tit">主Y轴</span><span class="txt"></span><br>
      <span class="tit">主轴Y轴的设置：</span><span class="txt">选择自动缩放以自动缩放轴。 最小-仅在不使用自动缩放时可用。设置轴的最小值。
        最大-仅在不使用自动缩放时可用。设置轴的最大值。</span><br>
      <span class="tit">副Y轴</span><span class="txt"></span><br>
      <span class="tit">副轴Y轴的设置：</span><span class="txt">选择自动缩放以自动缩放轴。 最小-仅在不使用自动缩放时可用。设置轴的最小值。
        最大-仅在不使用自动缩放时可用。设置轴的最大值。</span><br>

      <span class="tab">时间</span><br>
      <hr />
      <span class="tit">时间取值：</span><span class="txt">可选全部值,最新值,相对时间值,时间范围值.</span><br>
      <span class="tit">全部值：</span><span class="txt">选择所有的值读所有的值</span><br>
      <span class="tit">最新值：</span><span class="txt">选择最后时间阅读日志从目前趋势和逆向选择的时期。例子:今天的日期和时间是2020/09/21
        11:42:37。如果选择2个月，时间间隔将从2020/07/21 11:42:37开始。</span><br>
      <span class="tit">相对时间值：</span><span class="txt">选择相对时间获取的最新值趋势日志。例子:今天的日期是2020年9月21日，星期一，图表将覆盖从2020-09-14
        00:00:00到2020-09-21 23:59:59的趋势日志值。</span><br>
      <span class="tit">时间范围值：</span><span class="txt">选择一个绝对时间范围内的所有趋势值</span><br>

      <span class="tab">动态图</span><br>
      <hr />
      <span class="tit">对象列表：</span><span class="txt">选择要实时查看的点位,计算方式可选择求和平均值,最大值,最小值.
        ps:如果未选择计算方式,则无法查看趋势日志记录图</span><br>
      <span class="tit">添加：</span><span class="txt">选择添加多个点位</span><br>
      <span class="tit">删除：</span><span class="txt">选择删除多个点位</span><br>
      <!--<el-button @click="dialogHelp = false">取 消</el-button>
      <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
import moment from 'moment'
import eventBus from '../timeChart/vue.js'
export default {
  components: {

  },
  data() {
    return {
      dialogHelp: false,
      calculation: 'sum',
      cycle: 'no',
      cycles: [
        {
          label: '无',
          value: 'no'
        },
        {
          label: '分(m)',
          value: 'm'
        }, {
          label: '时(h)',
          value: 'h'
        }, {
          label: '天(d)',
          value: 'd'
        }
      ],
      calculations: [
        {
          value: 'no',
          label: '不计算'
        }, {
          value: 'sum',
          label: '求和'
        }, {
          value: 'avg',
          label: '求平均数'
        }, {
          value: 'min',
          label: '求最小值'
        }, {
          value: 'max',
          label: '求最大值'
        }],
      numTime: true,
      weekTime: true,
      weekTime1: true,
      startTime1: true,
      stopTime1: true,
      formDatas: {
        isWeek: true,
        date: '',
        isYear: false,
        date1: '',
        formDate: moment(),
        toDate: moment(),
        startTime: moment(),
        stopTime: moment()
      },
      startTime: moment().subtract(2, "days"),
      stopTime: moment(),
      /* startTime: moment(),
      stopTime: moment(), */
      defaultTime: moment(),
      logInterval_unitPeriod: 'w',
      num: 1,
      optionsPeriod: [
        {
          value: 'All values',
          label: '全部值'
        }, {
          value: 'Last period',
          label: '最新值'
        }, {
          value: 'Relative period',
          label: '相对时间值'
        }, {
          value: 'Absolute period',
          label: '时间范围值'
        }],
      valuePeriod: 'All values',
      valuePeriod1: 'w',
      checkList: ['近似值', '估计值', '已编辑值'],
      objectInfo: {},
      loading: false,
      activeName: 'first',
      form: {
        objectSeries: [],
        primaryY_autoScale: true,
        primaryY_Mininum: 0,
        primaryY_maximum: 100,
        secondaryY_autoScale: true,
        secondaryY_Mininum: 0,
        secondaryY_maximum: 100,
        logInterval_value: 1,
        logInterval_unit: 's',
        maxLogNum: ''
      },
      description: '',
      checked: '',
      options: [
        {
          label: '秒(s)',
          value: 's'
        }, {
          label: '分(m)',
          value: 'm'
        }, {
          label: '时(h)',
          value: 'h'
        }, {
          label: '天(d)',
          value: 'd'
        }, {
          label: '周(w)',
          value: 'd'
        }, {
          label: '月(M)',
          value: 'd'
        }, {
          label: '年(y)',
          value: 'd'
        }
      ],
      optionsd: [
        {
          label: '秒(s)',
          value: 's'
        }, {
          label: '分(m)',
          value: 'm'
        }, {
          label: '时(h)',
          value: 'h'
        }, {
          label: '天(d)',
          value: 'd'
        }, {
          label: '周(w)',
          value: 'd'
        }, {
          label: '月(M)',
          value: 'd'
        }, {
          label: '年(y)',
          value: 'd'
        }
      ],
      visibleAdd: false,
      visibleProperties: false,
      addList: [],
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      selectList: [],
      name: '',
      showList: [],
      row: '',
      isEdit: false,
      oldData: {}
    }
  },
  computed: {
    ...mapState({
      visible: 'onlineChartTrendShow',
      nodeData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    nodeData() {

    },
    visible() {
      debugger
      if (this.visible) {
        this.objectInfo = JSON.parse(JSON.stringify(this.nodeData))
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'trendChart') {
          this.isEdit = true
          this.activeName = 'first'
          this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
          this.description = this.objectInfo.description ? this.objectInfo.description : ''
          this.name = this.objectInfo.name ? this.objectInfo.name : ''
          console.log(this.objectInfo.attribute.trendLog)
          let arr = this.form.objectSeries = this.objectInfo.attribute.trendLog ? JSON.parse(JSON.stringify(this.objectInfo.attribute.trendLog)) : []
        } else {
          this.isEdit = false
          this.activeName = 'first'
          this.form = {
            objectSeries: [],
            primaryY_autoScale: true,
            primaryY_Mininum: 0,
            primaryY_maximum: 100,
            secondaryY_autoScale: true,
            secondaryY_Mininum: 0,
            secondaryY_maximum: 100,
            logInterval_value: 1,
            logInterval_unit: 's',
            maxLogNum: ''
          }
          this.description = ''
          this.name = ''
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'ONLINECHART_PROPERTIES_TREND_HIDE',
      needReload: 'NEED_RELOAD_TREE'
    }),

    delObjectSeriesArray(val) {
      this.form.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.form.objectSeries.splice(index, 1);
        }
      })
    },

    beforeClose() {
      this.close()
    },
    handleCloseHelp() {
      this.dialogHelp = false
    },
    // cancel () {
    //   this.nodeData = this.oldData
    //   this.close()
    // },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      if (!this.form.primaryY_autoScale) {
        if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      if (!this.form.secondaryY_autoScale) {
        if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
          this.$Message.warning('Y轴最小值必须小于最大值')
          return
        }
      }
      // done(false)可以阻止modal关闭
      done()
    },
    handleConfirm() {
      let _this = this
      this.loading = true
      let arr = []
      let arrs = []
      let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
      for (let i = 0; i < backArr.length; i++) {
        let data = { id: '', method: 'sum', period: '', name: '', type: 'trendLog', cycle: 'no', reckon: 'no' }
        data.id = backArr[i].id
        data.name = backArr[i].name
        data.method = backArr[i].reckon
        data.period = backArr[i].cycle
        arrs.push(data)
      }
      this.form.objectSeries.forEach(e => {
        arr.push(e.id)
      })
      this.form.objectSeries = arr
      if (this.objectInfo.id && this.objectInfo.type === 'trendChart') {
        this.form.trendLog = arrs
        let param = {
          id: this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          "sort": 100,
          "value": this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式
        }
        service.renamePoint(param).then(res => {
          this.loading = false
          this.$Message.success('修改成功')
          _this.objectInfo.attribute.objectSeries = backArr
          this.close()
          this.objectInfo.name = this.name
          res.attribute.objectSeries = backArr
          this.$store.state.tabPanel = res
          this.$store.state.updateTreeNode = res
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
          // eventBus.$emit('changeInterval', res)
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          /*'name': this.name,
          'type': 'onlineChart',
          'parentId': this.objectInfo.id,
          'description': this.description,
          'attribute': this.form // 其他信息这里，键值对形式*/
          name: this.name,
          type: "trendChart",
          parentId: this.objectInfo.id,
          description: this.description,
          attribute: {
            'startTime': this.startTime.valueOf(),
            'stopTime': this.stopTime.valueOf(),
            dateAndTimePeriod: {
              "All values": {}
            },
            trendLog: arrs
          }
        }
        service.newAddPoint(param).then(res => {
          this.loading = false
          this.$Message.success('添加成功')
          setTimeout(() => {
            res.attribute.objectSeries = backArr
            _this.$store.state.addTreeNode = res
          }, 0)
          this.close()
          this.description = ''
          this.name = ''
          // this.form = {
          //   objectSeries: []
          // }
          this.showList = []
        }).catch(err => {
          this.loading = false
          this.form.objectSeries = backArr
          this.$Message.error(err.message)
        })
      }
    },
    onChange(v) {

    },
    add() {
      let _this = this
      let id = ''
      if (_this.nodeData.type === 'device') {
        id = _this.nodeData.id
      } else {
        id = _this.nodeData.parentId
      }
      this.visibleAdd = true

      /* service.getTree('trendLog', id).then(res => {
        console.log(res)
        this.addList = res
        if (_this.form.objectSeries !== null && _this.form.objectSeries.length > 0) {
          setTimeout(() => {
            _this.form.objectSeries.forEach(res => {
              _this.$refs.tree.setChecked(res.id, true)
            })
          }, 0)
        }
      }) */
      if (this.nodeData.type == "server" || this.nodeData.type == "project") {
        /*  setTimeout(() => {
           _this.addList = this.$store.state.nodeAll;
         }, 2000) */
        service.getAllTree().then(res => {
          _this.addList = res;
        })
      }
      else if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('trendLog', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          setTimeout(() => {
            _this.addList = res;
          }, 2000)

        })
      } else {
        let ide = ''
        this.isEdit ? ide = this.nodeData.parentId : ide = this.nodeData.id
        service.getTree("trendLog", ide).then((res) => {
          this.addList = res;
          if (
            _this.form.objectSeries !== null &&
            _this.form.objectSeries.length > 0
          ) {
            setTimeout(() => {
              _this.form.objectSeries.forEach((res) => {
                _this.$refs.tree.setChecked(res.id, true);
              });
            }, 0);
          }
        });
      }
    },
    del() {
      if (this.selectList === null || this.selectList.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selectList.forEach((value, index, array) => {
        this.form.objectSeries = this.form.objectSeries.filter(e => {
          return e.id !== value.id
        })
      })
    },
    yAxis() {

    },
    property() {
      if (this.selectList.length !== 1) {
        this.$Message.warning('只能勾选一项')
        return
      }
      this.visibleProperties = true
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    closeAdd() {
      this.visibleAdd = false
    },
    handleConfirmAdd() {
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.form.objectSeries.push(e.data)
      })
      this.form.objectSeries = this.unique(this.form.objectSeries, 'id')
      this.visibleAdd = false
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    beforeCloseProperties() {
      this.visibleProperties = false
    },
    closeProperties() {
      this.visibleProperties = false
    },
    handleConfirmProperties() {
      this.visibleProperties = false
    },
    checkEvent(node, isSelect, halfSelect) {
      console.log(node)
      console.log(isSelect)
      console.log(halfSelect)
      //   value_Analog,
      // value_Multistate,
      // value_Binary,
      // value_String,
      // BinaryInput,
      // BinaryOutput,
      // AnalogInput,
      // AnalogOutput
      switch (node.type) {
        case 'value_Analog':
          break
        case 'value_Multistate':

          break
        case 'value_Binary':

          break
        case 'value_String':

          break
        case 'BinaryInput':

          break
        case 'BinaryOutput':

          break
        case 'AnalogInput':

          break
        case 'AnalogOutput':

          break
        case 'trendLog':

          break
        case 'squareWave':

          break
        case 'AnalogR':

          break
        case 'AnalogW':

          break
        case 'BinaryR':

          break
        case 'BinaryW':

          break
        case 'IntegerR':

          break
        case 'IntegerW':

          break
        case 'BinaryInputW':

          break
        case 'BinaryInputR':

          break
        case 'BinaryOutputW':

          break
        case 'BinaryOutputR':

          break
        case 'AnalogInputW':

          break
        case 'AnalogInputR':

          break
        case 'AnalogOutputW':

          break
        case 'AnalogOutputR':

          break
        case 'DigitalOutputW':

          break
        case 'DigitalOutputR':

          break
        case 'DigitalInputW':

          break
        case 'DigitalInputR':

          break

        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      }
    },
    selectData(selection, row) {
      this.selectList = selection
    }
  }
}
</script>
<style scoped>
.addTree {
  cursor: pointer;
  color: rgb(248, 121, 1);
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 200px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.time-event-dialog {
  &-modal {
    .top-form {
      display: flex;
    }

    .top-form-left {
      width: 50%;
    }

    .top-form-right {
      width: 50%;
      padding-left: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/left-side/onlineChartTrend.vue